import React from 'react';
import { StethoscopeIcon, TrophyIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustBadges } from './TrustBadges';
import { CHECKOUT_URLS } from '../data/checkout';
export function FinalCloseSection() {
  return <section className="w-full bg-beige py-16 sm:py-20" aria-labelledby="cierre-title" data-id="element-72" data-mp="39l80subngfti">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-73" data-mp="3emnmmolniqcy">
        <h2 id="cierre-title" className="mx-auto max-w-3xl text-center font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-petrol sm:text-4xl lg:text-5xl" data-id="element-74" data-mp="662hxk01yjfn">
          La diabetes no te saca el asado. Te saca el sistema que no tenías.{' '}
          <span className="text-cta-hover" data-id="element-75" data-mp="1796ry88n4in">Este es el sistema.</span>
        </h2>

        <div className="mx-auto mt-10 max-w-prose space-y-5 text-lg leading-relaxed text-body" data-id="element-76" data-mp="2gyn9ftv6c3py">
          <p data-id="element-77" data-mp="2h0zy0pvftcbz">
            ¿Te acordás de la escena del principio? La familia en la mesa. El asado. La ensalada rusa. El
            pan. Y alguien mirando todo en silencio, sin saber si puede comer — o cuánto.
          </p>
          <p className="font-display text-2xl font-bold leading-snug text-petrol" data-id="element-78" data-mp="16uzqzdpzsy67">
            Ese próximo domingo puede ser diferente.
          </p>
          <p data-id="element-79" data-mp="1kvkcihnal83e">
            No porque la diabetes desapareció. Sino porque ahora tenés el sistema que te dice exactamente
            qué hacer con ella: qué cocinar, cómo adaptarlo, con qué combinarlo, cuánto servir.
          </p>
          <p data-id="element-80" data-mp="1ptc0j0ktga2b">
            Para que el asado siga siendo el asado. Para que la mesa familiar siga siendo la mesa
            familiar. Para que comer vuelva a ser placer — y no miedo.
          </p>
          <p className="font-semibold text-petrol" data-id="element-81" data-mp="1ylnqklc0pvhr">
            Eso es lo que +1.200 personas en Argentina ya tienen en su cocina. Ahora te toca a vos.
          </p>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-2" data-id="element-82" data-mp="2dgtzph6euafb">
          <article className="flex h-full flex-col rounded-3xl border border-beige-deep bg-white p-7" data-id="element-83" data-mp="28kwfv0vxulxs">
            <div className="flex items-center gap-3" data-id="element-84" data-mp="2fo33q55v9udj">
              <StethoscopeIcon className="h-6 w-6 text-sage-deep" aria-hidden="true" data-id="element-85" data-mp="2km4joh7zxdks" />
              <h3 className="font-display text-lg font-bold text-petrol" data-id="element-86" data-mp="2kjs2w7dz599b">
                MegaPack Cocina Para Diabéticos
              </h3>
            </div>
            <p className="mt-3 text-sm text-body-muted" data-id="element-87" data-mp="2ucpr8u5ndsfu">6 Tomos + 6 Bonos · Todo el sistema completo</p>
            <div className="mt-auto pt-8" data-id="element-88" data-mp="2za93xpmp5x5o">
              <p className="font-display text-3xl font-extrabold text-petrol" data-id="element-89" data-mp="33cm9acxj7t1x">
                <span className="text-lg font-bold text-body-muted line-through" data-id="element-90" data-mp="33ep91oohl0ju">$51.000</span> $19.990{' '}
                <span className="text-base font-bold text-body-muted" data-id="element-91" data-mp="389w7agyzld1d">ARS</span>
              </p>
              <CtaButton href={CHECKOUT_URLS.megapack} size="md" className="mt-5 w-full" data-id="element-92" data-mp="3d8fu0jlemsus">
                Quiero recuperar mi cocina
              </CtaButton>
            </div>
          </article>

          <article className="relative flex h-full flex-col rounded-3xl border-2 border-cta bg-petrol p-7 text-white" data-id="element-93" data-mp="1iyvf2o9yb55e">
            <span className="absolute -top-3.5 left-7 inline-flex items-center gap-1.5 rounded-full bg-cta px-4 py-1.5 font-display text-xs font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-94" data-mp="16mjgez3paj5y">
              <StarIcon className="h-3.5 w-3.5 fill-white" aria-hidden="true" data-id="element-95" data-mp="wodl50cegba2" />
              Más elegido
            </span>
            <div className="flex items-center gap-3" data-id="element-96" data-mp="1ucdvlnbhsjtd">
              <TrophyIcon className="h-6 w-6 text-cta" aria-hidden="true" data-id="element-97" data-mp="1ua1d991to7fs" />
              <h3 className="font-display text-lg font-bold" data-id="element-98" data-mp="1pdkelkwzyaog">MegaPack + Kit Control Total</h3>
            </div>
            <p className="mt-3 text-sm text-white/75" data-id="element-99" data-mp="1kc3is3tddeeq">
              6 Tomos + 6 Bonos + Kit de seguimiento avanzado
            </p>
            <div className="mt-auto pt-8" data-id="element-100" data-mp="8yj74fgcggo8">
              <p className="font-display text-3xl font-extrabold text-cta" data-id="element-101" data-mp="8zkhsitg715f">
                <span className="text-lg font-bold text-white/60 line-through" data-id="element-102" data-mp="3zexxotf6ixw">$69.000</span> $27.990{' '}
                <span className="text-base font-bold text-white/70" data-id="element-103" data-mp="1ssuey8pu8wnu">ARS</span>
              </p>
              <CtaButton href={CHECKOUT_URLS.kitControlTotal} size="md" className="mt-5 w-full" data-id="element-104" data-mp="1xku6pdvr8j9c">
                Quiero el Kit Control Total
              </CtaButton>
            </div>
          </article>
        </div>

        <TrustBadges className="mt-10 justify-center" guaranteeLabel="Garantía 7 días sin preguntas" paymentLabel="Mercado Pago · Tarjeta · Transferencia" data-id="element-105" data-mp="1nvkii9417kqi" />
      </div>
    </section>;
}